<template>
  <div class="breadcrumbs">
    <ul class="breadcrumbs__list">
      <li>
        <a href="https://alvaroapoio.com.br/">Home</a>
      </li>
      <li>
        <a href="/exames">Guia de Exames</a>
      </li>
      <li v-if="$route.name !== 'Exames'">
        <span>{{ lastLinkText }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Breadcrumbs',
  props: ['examName'],
  computed: {
    lastLinkText() {
      let text = this.$route.name
      if (this.examName) {
        text = this.examName
      }
      return text
    }
  }
}
</script>

<style lang="scss">
.breadcrumbs {
  padding: 10px 20px;

  &__list {
    display: flex;

    li {
      margin: 0 !important;

      &:after {
        content: '>';
        margin-left: 5px;
        margin-right: 5px;
        color: #7f1a54 !important;
        font-style: italic;
        font-weight: 500;
      }

      &:last-of-type:after {
        display: none;
      }

      a,
      span {
        color: #7f1a54 !important;
        font-weight: 500;
        font-size: 11px;
      }
    }
  }
}
</style>
